// Generated by GitHub Copilot
import { Api } from '#core/api/Api.ts'
import CompanyInvitation from '#core/entities/auth/companies/CompanyInvitation.ts'
import CompanyInvitationIssue from '#core/entities/auth/companies/CompanyInvitationIssue.ts'
import UserCompany from '#core/entities/auth/users/UserCompany.ts'
import type { Permission } from '#core/entities/auth/roles/Permission.ts'

/**
 * Company-scoped invitation management.
 * Authenticated endpoints require `AUTH_USERS` permission.
 * The accept endpoint is public (token-based).
 */
export default class CompanyInvitationsApi extends Api<CompanyInvitationsApi> {
  constructor() {
    super()
  }

  /** Lists all invitations for the current company. */
  async listInvitations(): Promise<CompanyInvitation[]> {
    return (await this.get<CompanyInvitation[]>('auth/company-invitations/', undefined, CompanyInvitation)) ?? []
  }

  /** Returns a single invitation by ID. */
  async getInvitation(id: string): Promise<CompanyInvitation | null> {
    return this.get<CompanyInvitation>(`auth/company-invitations/${id}`, undefined, CompanyInvitation)
  }

  /** Creates a new invitation and returns it with the accept token. */
  async createInvitation(
    email: string,
    roleId?: string | null,
    personalPermissions?: Permission[] | null,
    expiresInHours?: number,
  ): Promise<CompanyInvitationIssue | null> {
    return this.post<CompanyInvitationIssue>(
      'auth/company-invitations/',
      {
        email,
        role_id: roleId,
        personal_permissions: personalPermissions,
        expires_in_hours: expiresInHours,
      },
      CompanyInvitationIssue,
    )
  }

  /** Resends an invitation and returns a fresh accept token. */
  async resendInvitation(id: string): Promise<CompanyInvitationIssue | null> {
    return this.post<CompanyInvitationIssue>(`auth/company-invitations/${id}/resend`, undefined, CompanyInvitationIssue)
  }

  /** Revokes an invitation. */
  async revokeInvitation(id: string): Promise<CompanyInvitation | null> {
    return this.post<CompanyInvitation>(`auth/company-invitations/${id}/revoke`, undefined, CompanyInvitation)
  }

  /** Accepts an invitation using its token (public, no auth required). */
  async acceptInvitation(
    token: string,
    firstName?: string | null,
    lastName?: string | null,
    password?: string | null,
  ): Promise<UserCompany | null> {
    return this.post<UserCompany>(
      `auth/company-invitations/${token}/accept`,
      {
        first_name: firstName,
        last_name: lastName,
        password,
      },
      UserCompany,
    )
  }
}
